import { createLogger } from "@fluentry/core";
import type { Logger, LogContext } from "@fluentry/domain";

type LoggerParams = {
  scope: string;
  env?: Record<string, any>;
  request?: Request;
  context?: LogContext;
};

function getRequestId(request?: Request): string | undefined {
  if (!request) return undefined;
  return request.headers.get("cf-ray") || request.headers.get("x-request-id") || undefined;
}

export function createRequestLogger({ scope, env, request, context }: LoggerParams): Logger {
  const requestId = getRequestId(request);
  const baseContext = context ?? {};
  return createLogger({
    env,
    context: {
      scope,
      requestId,
      ...baseContext,
    },
  });
}
